import { useState } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {
    const blogs = [
        {
            title: "Why Sunday School Still Matters in Today’s World",
            excerpt:
                " Discover why Sunday School remains a cornerstone of faith, character, and community in our modern age.",
            author: "Juby Varghese",
            date: "Oct 10, 2025",
            image: "images/blog-related.png",
            link: "/blogs/why-sunday-school-still-matters",
        },
        {
            title: "Raising the Next Generation of Faith Through Sunday School",
            excerpt:
                "Explore how Sunday School continues to nurture faith, character, and leadership in young hearts today.",
            author: "John Smith",
            date: "Oct 10, 2025",
            image: "images/raising-next-generation.png",
            link: "/blogs/raising-next-generation-of-faith",
        },
        {
            title: "How Early Spiritual Education Shapes Lifelong Believers",
            excerpt:
                "Discover how nurturing faith in early childhood builds resilient, compassionate, and lifelong believers.",
            author: "Emily Johnson",
            date: "Oct 10, 2025",
            image: "images/early-education.png",
            link: "/blogs/early-spiritual-education",
        },
        {
            title: "Behind the Scenes: The Heart of a Sunday School Teacher",
            excerpt:
                "Discover the dedication, passion, and love that Sunday School teachers pour into shaping the next generation of faith.",
            author: "Michael Brown",
            date: "Oct 11, 2025",
            image: "images/teacher.png",
            link: "/blogs/heart-of-sunday-school-teacher",
        },
        {
            title: "How Sunday School Builds Strong Families and Strong Churches",
            excerpt:
                "Discover how Sunday School strengthens families, supports parents, and nurtures vibrant church communities.",
            author: "Michael Brown",
            date: "Oct 11, 2025",
            image: "images/family.png",
            link: "/blogs/strong-families-and-churches",
        },
        {
            title: "The Power of God’s Word: Lessons That Transform Young Hearts",
            excerpt:
                "Discover how Scripture shapes values, character, and faith in children, creating a foundation for lifelong growth.",
            author: "Michael Brown",
            date: "Oct 11, 2025",
            image: "images/power.png",
            link: "/blogs/power-of-gods-word",
        },
        {
            title: "Why Every Christian Should Stay Connected to the Church",
            excerpt:
                "Discover the importance of church community for spiritual growth, accountability, service, and a faith that lasts.",
            author: "Michael Brown",
            date: "Oct 11, 2025",
            image: "images/connection.png",
            link: "/blogs/stay-connected-church",
        },
        {
            title: "How Parents Can Support Their Children's Faith at Home",
            excerpt:
                "Practical ways for parents to nurture faith, values, and a personal relationship with God in the family.",
            author: "Michael Brown",
            date: "Oct 12, 2025",
            image: "images/parents-support.png",
            link: "/blogs/parents-support-faith",
        },
        {
            title: "Building the Future Church — One Sunday School Class at a Time",
            excerpt:
                "How Sunday School nurtures the next generation of faithful, committed, and active church members.",
            author: "Michael Brown",
            date: "Oct 12, 2025",
            image: "images/future.png",
            link: "/blogs/future-church",
        },
        {
            title: "How Investing in Young Believers Ensures a Strong Church for Generations",
            excerpt:
                "Nurturing children and youth today secures the Church's faith, leadership, and impact for tomorrow.",
            author: "Michael Brown",
            date: "Oct 13, 2025",
            image: "images/investment.png",
            link: "/blogs/young-believers",
        },
    ];

    const cardsPerPage = 3;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(blogs.length / cardsPerPage);

    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentBlogData = blogs.slice(startIndex, endIndex);

    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    return (
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
            <section className="bg-primary text-white text-center py-20 px-6">
                <h1 className="text-5xl md:text-6xl font-extrabold mb-4">📚 Our Blog</h1>
                <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8">
                    Stay updated with the latest insights, tips, and news about online learning, productivity, and technology.
                </p>
            </section>

            <section className="py-16 px-6 max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-gray-800 text-center mb-12">Latest Articles</h2>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {currentBlogData.map((blog, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col"
                        >
                            <img src={blog.image} alt={blog.title} className="w-full h-48 object-cover" />
                            <div className="p-6 flex flex-col flex-grow">
                                <Link to={blog.link}>
                                    <h3 className="text-xl font-semibold text-primary mb-2 hover:underline">
                                        {blog.title}
                                    </h3>
                                </Link>
                                <p className="text-gray-700 text-sm flex-grow">{blog.excerpt}</p>
                                <div className="mt-4 flex items-center justify-between text-gray-500 text-xs">
                                    <span>{blog.author}</span>
                                    <span>{blog.date}</span>
                                </div>
                                <Link
                                    to={blog.link}
                                    className="mt-4 bg-primary hover:bg-blue-600 text-white px-4 py-2 rounded-full transition self-start"
                                >
                                    Read More →
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex justify-between mt-12 max-w-3xl mx-auto">
                    <button
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        className={`flex items-center px-4 py-2 rounded font-semibold transition ${currentPage === 1
                                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                : "bg-primary text-white hover:bg-blue-600"
                            }`}
                    >
                        <span className="mr-2">←</span> Previous
                    </button>

                    <button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        className={`flex items-center px-4 py-2 rounded font-semibold transition ${currentPage === totalPages
                                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                : "bg-primary text-white hover:bg-blue-600"
                            }`}
                    >
                        Next <span className="ml-2">→</span>
                    </button>
                </div>
            </section>
        </div>
    );
};

export default Blogs;